import type { ReactNode } from "react"
import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { IconBadge } from "./icon-badge"

// Top-of-page summary card: icon-badge top-left, delta chip top-right,
// big value, smaller label. Used in the agents-overview row + future
// dashboards.
type Props = {
  icon: ReactNode
  label: string
  value: string
  delta?: string
  deltaTone?: "gold" | "red" | "neutral"
}

export function MetricCard({ icon, label, value, delta, deltaTone = "gold" }: Props) {
  return (
    <Card className="p-5">
      <div className="mb-5 flex items-center justify-between">
        <IconBadge>{icon}</IconBadge>
        {delta && <Badge tone={deltaTone}>{delta}</Badge>}
      </div>
      <div className="text-3xl font-semibold tracking-tight text-app-text">{value}</div>
      <div className="mt-1 text-sm text-app-muted">{label}</div>
    </Card>
  )
}
